import styled from 'styled-components'

export const QuestionTitle = styled.h3`
  font-size: 18px;
  text-transform: uppercase;
  color: #525961;
  margin: 0;
  text-align: left;
`
